import { Typography } from "@mui/material"

export default function Help() {
    return (
        <>
            <Typography variant="h1">Help Centre</Typography>
            <Typography variant="h2">Learn how to use CareSync.</Typography>
        </>
    )
}